import React, { useEffect } from "react";
import { AddonInterface } from "../../../../store/mine_craft/addonsSlice";

import {Button, Form, Input, Switch} from "antd";
import FileDropzone from "../../../../componets/FileDropzone";

interface propsInterface {
  params?: AddonInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-group-dropzone'>
        <FileDropzone name='image' label='Image' preview={params?.image_url} />
        <FileDropzone name='texture' label='Texture' preview={params?.texture_url} />
        <FileDropzone name='zip' label='Zip' preview={params?.zip_url} />
      </div>

      <Form.Item label="Published" name='published' valuePropName='checked'>
        <Switch />
      </Form.Item>

      <Form.Item name='title' label="Title">
        <Input placeholder='Title' />
      </Form.Item>

      <Form.Item name='description' label="Description">
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item name='description_html' label="Body HTML">
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item name='search_text' label="Search Text">
        <Input.TextArea rows={3} />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
